import React from 'react';
import PageTitle from '../layout/PageTitle';

const Terms: React.FC = () => {
  return (
    <div className="content">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <PageTitle title="Terms of Service" />

        <div className="bg-brand-card/60 backdrop-blur-md border border-brand-border rounded-xl p-6 md:p-8 space-y-6 text-white/80 text-sm leading-relaxed">
          <h1 className="text-2xl font-bold text-white mb-4">Terms of Service</h1>
          <p className="text-white/60 text-xs">Last updated: January 2026</p>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Acceptance of Terms</h2>
            <p>
              By accessing or using SentiHype (“Service”), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. Description of Service</h2>
            <p>
              SentiHype is an informational platform that aggregates and analyzes social media sentiment about stocks and cryptocurrencies. The Service provides data, charts, and metrics for informational and research purposes only.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Not Financial Advice</h2>
            <p>
              THE SERVICE DOES NOT PROVIDE INVESTMENT ADVICE, RECOMMENDATIONS, OR FINANCIAL COUNSELING. All content, data, and materials are for informational purposes only. You should not rely on the Service for any investment decisions. Always conduct your own research and consult qualified financial advisors before making any financial decisions.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. No Warranty; Disclaimer</h2>
            <p>
              THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. We do not warrant that the Service will be uninterrupted, error-free, or free of harmful components. We disclaim all warranties, including implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, SENTIHYPE, ITS OWNERS, OPERATORS, AND AFFILIATES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, OR GOODWILL. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID FOR THE SERVICE IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Intellectual Property</h2>
            <p>
              All content, trademarks, logos, and materials on the Service are the property of SentiHype or its licensors. You may not copy, modify, distribute, or create derivative works without our prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">7. User Conduct</h2>
            <p>
              You agree not to: (a) use the Service for any illegal purpose; (b) attempt to gain unauthorized access to our systems or other users’ accounts; (c) interfere with or disrupt the Service; (d) scrape or harvest data without permission; (e) resell or redistribute the Service without authorization.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">8. Subscription and Payment</h2>
            <p>
              Paid subscriptions are billed in advance. Fees are non-refundable unless required by law. We reserve the right to change pricing with reasonable notice. Continued use after a price change constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">9. Termination</h2>
            <p>
              We may suspend or terminate your access at any time for violation of these Terms or for any other reason. Upon termination, your right to use the Service ceases immediately.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">10. Changes to Terms</h2>
            <p>
              We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the modified Terms. We encourage you to review these Terms periodically.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">11. Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of the jurisdiction in which SentiHype operates, without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">12. Contact</h2>
            <p>
              For questions about these Terms: <a href="https://t.me/sentihype" target="_blank" rel="noopener noreferrer" className="text-brand-cyan hover:underline">Telegram</a>, <a href="mailto:info@sentihype.com" className="text-brand-cyan hover:underline">info@sentihype.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
